export enum ScheduledNotificationType {
  Custom = 'Custom',
  RewardsBalance = 'Rewards Balance',
}

export enum DeepLinkUrls {
  CustomerCRD = 'Customer CRD link',
  CustomerWallet = 'Customer CRD link wallet',
  CustomerPromotions = 'Customer CRD link promotions',
}

export const FrenchSuffix = ' (french)';

export enum InsertVariables {
  AccountName = 'account name',
  RetailerName = 'retailer name',
  CampaignName = 'campaign name',
  PointsExpiringOnSpecifiedDate = 'points expiring on specified date',
  PointsExpiringOnSpecifiedDateFrench = `points expiring on specified date${FrenchSuffix}`,
  CurrentProgramPeriodEndDate = 'current program period end date',
  CurrentProgramPeriodEndDateFrench = `current program period end date${FrenchSuffix}`,
  RetailerPoints = 'number of available retailer points',
  RetailerPointsFrench = `number of available retailer points${FrenchSuffix}`,
  ManufacturerPoints = 'number of available manufacturer points',
  ManufacturerPointsFrench = `number of available manufacturer points${FrenchSuffix}`,
}

export enum ScheduledNotificationCommunicationType {
  Insights = 'Insights',
  PointsExpiration = 'Points Expiration',
  ProgramRollover = 'Program Roll-over',
  Promotions = 'Promotions',
  ReachNextTier = 'Reach Next Tier',
  ReEarnYourStatus = 'Re-earn Your Status',
  RewardsProgram = 'Rewards Program',
  UsingPoints = 'Using Points',
}
